module.exports = __webpack_public_path__ + "img/b5d372b196e94d9fa44e5c967187473d-1024.261c17c6.jpg";